export const ORDER_STATUS = {
  DRAFT: 'DRAFT',
  WAITING: 'WAITING',
  VALIDATED: 'VALIDATED',
  BLOCKED_BUSINESS: 'BLOCKED_BUSINESS',
  BLOCKED_OPERATOR: 'BLOCKED_OPERATOR',
  CANCELED: 'CANCELED',
  IN_PROGRESS: 'IN_PROGRESS',
  SENT_TO_BU_MANAGER: 'SENT_TO_BU_MANAGER',
} as const
